import { PlayCircleFilledRounded } from '@material-ui/icons';
import { Huddle, Request, RequestStatus } from 'lib/generated/graphql';
import Link from 'next/link';
import React, { useRef } from 'react';
import ReactPlayer from 'react-player';
import { Avatar } from 'src/shared-components';
import useAuth from 'src/shared-components/Auth';
import TeamButton from 'src/shared-components/HuddleCard/Huddle/components/TeamButton';
import Modal from 'src/shared-components/Modal';

const DEFAULT_USER_AVATAR = process.env.DEFAULT_USER_AVATAR || '';
const DEFAULT_COMPANY_AVATAR = process.env.DEFAULT_COMPANY_AVATAR || '';

const CompanyInfo = ({
  request,
  explore,
  huddle,
  openTeamModal,
}: {
  request: Request;
  explore?: boolean;
  huddle?: Huddle;
  openTeamModal?: () => void;
}) => {
  const companyVideoRef = useRef<any>();
  const openCompanyVideo = () => companyVideoRef.current.open();
  const playerRef = useRef<ReactPlayer>(null);
  const { user } = useAuth();

  const updateLoomVideoUrl = (url: string) => {
    const embedUrl = url.replace('share', 'embed');
    return embedUrl;
  };

  // const isCompanyFollowed = companyId => {
  //   return user?.companiesFollowed.some(companyFollow => companyFollow.following.id === companyId);
  // };

  return (
    <div className={explore ? 'block' : 'flex'}>
      <div className="flex">
        <div className="pb-2">
          <Link href={`/${request?.company?.slug}`}>
            <a>
              <Avatar isLink image={request?.company?.photoUrl || DEFAULT_COMPANY_AVATAR} size="xs" roundness="full" />
            </a>
          </Link>
        </div>
        <div className="h-7 w-7 relative mt-6 -ml-4 hover:opacity-80">
          <Link href={`/${request?.company?.customer?.username}`}>
            <a>
              <Avatar
                isLink
                image={request?.company?.customer?.photoUrl || DEFAULT_USER_AVATAR}
                size="xxsmall"
                roundness="full"
                username={request?.company?.customer?.username}
              />
              {/* <Image
                className="rounded-[10px]"
                layout="fill"
                username={request?.company?.customer?.username}
                src={request?.company?.customer?.photoUrl || DEFAULT_USER_AVATAR}
              /> */}
            </a>
          </Link>
        </div>
        {huddle?.teamLead && explore && (
          <div className="ml-auto">
            <TeamButton huddle={huddle} openTeamModal={openTeamModal} />
          </div>
        )}
        {/* {explore && (
          <div className="ml-auto">
            <CompanyFollow companyId={request.companyId} follows={isCompanyFollowed(request.companyId)} />
          </div>
        )} */}
      </div>
      <div className={explore ? 'ml-0 mt-2' : 'ml-4'}>
        <div className="flex items-center">
          <Link
            href={
              request?.status === RequestStatus.Approved ? `/huddles/${request?.slug}` : `/${request?.company?.slug}`
            }
          >
            <a className="text-[21px] mr-3 font-bold">{request?.company?.name}</a>
          </Link>
          {request?.company?.videoUrl && (
            <div className="text-[14px] font-medium underline cursor-pointer" onClick={() => openCompanyVideo()}>
              <PlayCircleFilledRounded fontSize="small" aria-hidden="true" className="mr-1" />
              Watch Video
            </div>
          )}
        </div>
        <div className="text-[14px] text-[#797979] font-medium">{request?.company?.pitch}</div>
      </div>
      <Modal ref={companyVideoRef}>
        {request?.company?.videoUrl?.includes('loom') ? (
          <iframe
            src={updateLoomVideoUrl(request?.company?.videoUrl)}
            allowFullScreen
            name="welcome-video"
            className="max-w-3xl aspect-video w-full sm:w-[90vw]"
          ></iframe>
        ) : (
          <div className="max-w-3xl aspect-video w-full sm:w-[90vw]">
            <ReactPlayer url={request?.company?.videoUrl} ref={playerRef} controls width="100%" height="100%" />
          </div>
        )}
      </Modal>
    </div>
  );
};

export default CompanyInfo;
